import { ApartmentCompareChartData, ApartmentTransactionItem } from '../type/ApartmentCompare.type';
import { AssetReport } from '../../assetReport/type/AssetReport.type';
import { getNetAssetTotalAmount } from '../../assetReport/util/AssetStatusCard.util';

export const buildApartmentCompareChartData = (
  assetReportList: AssetReport[],
  transactionList: ApartmentTransactionItem[],
): ApartmentCompareChartData[] => {
  if (!assetReportList || assetReportList.length === 0) return [];

  const sortedReports = [...assetReportList].sort((a, b) => a.yearMonth.localeCompare(b.yearMonth));

  const assetMap = new Map<string, AssetReport>();
  sortedReports.forEach((r) => assetMap.set(r.yearMonth, r));

  const transactionMap = new Map<string, number>();
  transactionList.forEach((t) => transactionMap.set(t.yearMonth, t.price));

  const assetStart = sortedReports[0].yearMonth;
  const assetEnd = sortedReports[sortedReports.length - 1].yearMonth;

  // 자산 데이터 시작 이전의 가장 최근 거래가로 초기화
  const lastPriceBeforeStart = transactionList
    .filter((t) => t.yearMonth < assetStart)
    .sort((a, b) => b.yearMonth.localeCompare(a.yearMonth))[0]?.price;

  // 자산 시작~끝 구간의 모든 월 생성
  const months: string[] = [];
  let current = assetStart;
  while (current <= assetEnd) {
    months.push(current);
    const [y, m] = current.split('-').map(Number);
    current = m === 12 ? `${y + 1}-01` : `${y}-${String(m + 1).padStart(2, '0')}`;
  }

  let lastKnownPrice: number | undefined = lastPriceBeforeStart;

  return months.map((ym) => {
    if (transactionMap.has(ym)) {
      lastKnownPrice = transactionMap.get(ym);
    }
    const report = assetMap.get(ym);
    return {
      yearMonth: ym,
      netAssetManwon: report ? Math.round(getNetAssetTotalAmount(report.reportItemList) / 10000) : undefined,
      aptPrice: lastKnownPrice,
    };
  });
};

// 최근 N개월 YYYY-MM 목록 반환 (오름차순)
export const getRecentYearMonths = (count: number): string[] => {
  const result: string[] = [];
  const date = new Date();
  // 당월 데이터는 아직 없을 수 있으므로 1달 전부터 시작
  date.setMonth(date.getMonth() - 1);
  for (let i = 0; i < count; i++) {
    result.unshift(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}`);
    date.setMonth(date.getMonth() - 1);
  }
  return result;
};
